import React from 'react';
import PropTypes from 'prop-types';
import {animateScroll as scroll} from 'react-scroll';
import CustomerAuth from './components/auth';
import UserData from './components/UserData';
import Block from './components/Block';
import {round} from "../../utils/func";
import {Button, buttonTypes} from '../../components/Button';
import Popup from '../../components/Popup';
import SelectTypeModal from './components/SelectPaymentType';
import './Booking.scss';
import routerConfig from "../../config/router";

class Booking extends React.Component {

  state = {
    totalPrices: {},
    isShowPopup: false,
    popupData: {},
    isShowSelectPaymentTypeModal: false,
    wrongUserType: false,
  };

  componentWillMount() {
    if (this.props.list.length > 0) {
      this.props.getCartTours();
      this.logoutForTourVendor(this.props);
    } else {
      this.props.history.push(routerConfig.home)
    }
  }

  componentWillReceiveProps(next) {
    this.logoutForTourVendor(next);
  }

  logoutForTourVendor = (p) => {
    if (
      p.userData &&
      p.userData.vendorType &&
      p.userData.vendorType === 'tour' &&
      !p.promiseLogout.isPending
    ) {
      this.setState({wrongUserType: true}, () => {
        setTimeout(() => {
          this.setState({wrongUserType: false})
        }, 3000)
      })
      p.logout();
    }
    if (
      p.userData &&
      p.userData.isAdmin &&
      !p.promiseLogout.isPending
    ) {
      p.logout();
    }
  };

  setBlockTotalPrice = (p) => {
    this.setState({totalPrices: Object.assign(this.state.totalPrices, p)})
  };

  calculateTotalPrice() {
    const {totalPrices} = this.state;
    const tPKeys = Object.keys(totalPrices);
    let result = 0;
    for (let i = 0; i < tPKeys.length; i++) {
      result += +totalPrices[tPKeys[i]]
    }
    return round(result)
  }

  buy = () => {
    const {
      list,
      isAuthorized
    } = this.props;
    if (list && list.length > 0)
      if (isAuthorized)
        this.setState({
          isShowPopup: true,
          popupData: {
            title: (<div>Loading ...</div>),
            body: (<p className="center-value">Saving now...</p>)
          }
        }, () => {
          this.props.buy({
            orders: list.map((l) => {
              return {
                tourId: l.id,
                persons: l.persons,
                date: l.date,
                timeSlotId: l.timeSlotId,
                guide: l.guide,
                meetingPlace: this.props.metingPlace,
              }
            }),
          });
        });
      else {
        this.setState({
          isShowPopup: true,
          popupData: {
            title: (<div>Please log in</div>),
            body: null
          }
        })
      }
  };

  closePopup = () => {
    this.setState({isShowPopup: false, popupData: {}})
  };

  closePaymentTypeModal = () => {
    this.setState({isShowSelectPaymentTypeModal: false})
  };

  onSelectedType = (type) => {
    const {
      list
    } = this.props;
    this.setState({
      isShowSelectPaymentTypeModal: false,
      isShowPopup: true,
      popupData: {
        title: (<div>Loading ...</div>),
        body: (<p className="center-value">Saving now...</p>)
      }
    }, () => {
      this.props.buy({
        orders: list.map((l) => {
          return {
            tourId: l.id,
            persons: l.persons,
            date: l.date,
            timeSlotId: l.timeSlotId,
            guide: l.guide,
            meetingPlace: this.props.metingPlace,
          }
        }),
        paySystem: type
      });
    });
  };

  render() {
    const {
      isShowPopup,
      popupData,
      isShowSelectPaymentTypeModal,
      wrongUserType,
    } = this.state;

    const {
      isAuthorized,
      userData,
      list,
      listOfTours,
      cities,
      metingPlace,
    } = this.props;
    return (
      <div className="booking">
        <h2 className="booking__title">Booking</h2>
        {wrongUserType && <p className="error-mess">Wrong user type</p>}
        <div className="booking__body">
          {
            isAuthorized ?
              <UserData
                {...userData}
              /> :
              <CustomerAuth
                onChangedTemplate={()=>scroll.scrollToTop({duration: 10})}
              />
          }
          {
            isShowPopup &&
            <Popup
              isShow={isShowPopup}
              close={this.closePopup}
              {...popupData}
            />
          }
          {
            isShowSelectPaymentTypeModal &&
            <SelectTypeModal
              isShowSelectTypeModal={isShowSelectPaymentTypeModal}
              onClosePaymentTypeModal={this.closePaymentTypeModal}
              onSelectedType={this.onSelectedType}
            />
          }
          <ol className="booking__list">
            {
              listOfTours.map((tour) => {
                for (let i = 0; i < list.length; i++) {
                  if (tour.id === list[i].id) {
                    return (
                      <Block
                        key={`home-tour-${tour.id}`}
                        {...tour}
                        selectedData={list[i]}
                        cities={cities}
                        metingPlace={metingPlace}
                        onTotalPrice={this.setBlockTotalPrice}
                      />
                    )
                  }
                }
                return null;
              })
            }
          </ol>
        </div>
        <div className="cart__book">
          <p className="cart__book-price">
            <span className="cart__book-label">Total Price </span>
            <span className="cart__book-content">$ {this.calculateTotalPrice()}</span>
          </p>
          <Button
            type={buttonTypes.AUTHENTICATION}
            name="PAY"
            onClick={this.buy}
          />
        </div>
      </div>
    )
  }
}

Booking.propTypes = {
  isAuthorized: PropTypes.bool,
  userData: PropTypes.object,
  list: PropTypes.array,
  getCartTours: PropTypes.func,
  listOfTours: PropTypes.array,
  cities: PropTypes.array,
  metingPlace: PropTypes.object,
  buy: PropTypes.func,
  history: PropTypes.object,
};

export default Booking;


// WEBPACK FOOTER //
// ./src/app/containers/Booking/Component.js